import Session from 'models/session'
export default new Session();

